import {HttpRequest, HttpMethod} from "./http";

class AccountProvider extends HttpRequest {
    // Account Items (Categories)
    ItemList(params) {
        return this.request(HttpMethod.Get, `/api/v3/account/items`, params);
    }

    // Platforms an expense category may be bound to (bo-api 2026-10-26)
    PlatformList() {
        return this.request(HttpMethod.Get, `/api/v3/account/platforms`);
    }

    ItemDetail(id) {
        return this.request(HttpMethod.Get, `/api/v3/account/items/${id}`);
    }

    ItemCreate(params) {
        return this.request(HttpMethod.Post, `/api/v3/account/items`, params);
    }

    ItemUpdate(id, params) {
        return this.request(HttpMethod.Put, `/api/v3/account/items/${id}`, params);
    }

    ItemDelete(id) {
        return this.request(HttpMethod.Delete, `/api/v3/account/items/${id}`);
    }

    // Account Records (Transactions)
    RecordList(params) {
        return this.request(HttpMethod.Get, `/api/v3/account/records`, params);
    }

    RecordDetail(id) {
        return this.request(HttpMethod.Get, `/api/v3/account/records/${id}`);
    }

    RecordCreate(params) {
        return this.request(HttpMethod.Post, `/api/v3/account/records`, params);
    }

    RecordUpdate(id, params) {
        return this.request(HttpMethod.Put, `/api/v3/account/records/${id}`, params);
    }

    RecordDelete(id) {
        return this.request(HttpMethod.Delete, `/api/v3/account/records/${id}`);
    }

    // Batch creation
    RecordCreateBatch(params) {
        return this.request(HttpMethod.Post, `/api/v3/account/records/batch`, params);
    }

    // Record Documents (Attachments)
    RecordDocumentList(recordId) {
        return this.request(HttpMethod.Get, `/api/v3/account/records/${recordId}/documents`);
    }

    RecordDocumentUpload(recordId, formData) {
        return this.request(HttpMethod.Post, `/api/v3/account/records/${recordId}/documents`, formData);
    }

    RecordDocumentUrl(recordId, docId) {
        return this.request(HttpMethod.Get, `/api/v3/account/records/${recordId}/documents/${docId}`);
    }

    RecordDocumentDelete(recordId, docId) {
        return this.request(HttpMethod.Delete, `/api/v3/account/records/${recordId}/documents/${docId}`);
    }

    // Reports
    ReportSummary(params) {
        return this.request(HttpMethod.Get, `/api/v3/account/reports/summary`, params);
    }

    ReportByUser(params) {
        return this.request(HttpMethod.Get, `/api/v3/account/reports/by-user`, params);
    }

    ReportByItem(params) {
        return this.request(HttpMethod.Get, `/api/v3/account/reports/by-item`, params);
    }

    ReportByDate(params) {
        return this.request(HttpMethod.Get, `/api/v3/account/reports/by-date`, params);
    }
}

export default AccountProvider;
